document.addEventListener("DOMContentLoaded", function() {
    const readMore = document.querySelector(".read-more");
    const readLess = document.querySelector(".read-less");
    const shortSpec = document.querySelector(".short-spec");
    const fullSpec = document.querySelector(".full-spec");

    readMore.addEventListener("click", function() {
        shortSpec.style.display = "none";
        fullSpec.style.display = "block";
    });

    readLess.addEventListener("click", function() {
        fullSpec.style.display = "none";
        shortSpec.style.display = "block";
    });
});

